<template>
  <transition name="modal">
    <div class="modalcon">
      <div class="modal-mask" @click="toggleModal">
        <div class="modal-wrapper">
          <div class="modal-container" @click.stop>
            <span class="closebtn" @click="toggleModal">
              <i class="fa fa-close" aria-hidden="true"></i>
            </span>
            <div class="clearfix"></div>
            <div class="mbox">
                <div class="modal-body mb0">
                  <div class="fbold text-center title" v-if="title">{{ title }}</div>
                  <slot></slot>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
  var $ = require('jquery')
  window.jQuery = $

  export default {
    props: ['toggleModal', 'title', 'handlePopupDestroy'],
    created () {
      $('body').addClass('_freeze')
    },
    beforeDestroy () {
      $('body').removeClass('_freeze')
    },
    destroyed () {
      if (this.handlePopupDestroy) {
        this.handlePopupDestroy()
      }
    }
  }
</script>

<style lang="css" scoped>

  .title {
    color: #90050d;
    font-size: 24px;
    margin-bottom: 5px;
  }

  .modal-header {
    border: none;
  }

  .closebtn {
    background: #90050d;
    border-radius: 24px;
    padding: 2px 7px;
    color: #fff;
    position: absolute;
    margin-top: -12px;
    right: -12px;
    cursor: pointer;
  }

  .closebtn:hover {
    background: #73040a;
  }

  .modalcon {
    position: fixed;
    display: block;
    left: 0;
    z-index: 9998;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    overflow-x: hidden;
    overflow-y: auto;
    transition: opacity .3s ease;
  }

  .modal-mask {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: table;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }

  .modal-container {
    width: 500px;
    margin: 0px auto;
    transition: all .3s ease;
    position: relative;
  }

  .mbox {
    background: #fff;
    padding: 10px;
    padding-bottom: 0;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    height: inherit;
    letter-spacing: 0px;
    text-align: left;
  }

  .modal-header,
  .modal-body {
    padding: 5px 10px;
  }

  .modal-enter {
    opacity: 0;
  }

  .modal-enter .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }

  @media screen and (max-width: 768px) {
    .modal-container {
      width: 92%;
    }
  }

  @media screen and (max-width: 480px) {
    .mbox {
      padding: 0;
      height: inherit;
    }
  }
</style>



// WEBPACK FOOTER //
// popupModal.vue?4bdd1e57